import LoadingButton from '@enerex/unified-ui-react/LoadingButton';
import { CommodityIcon } from 'pages/utilities/CommodityIcons';

const getCommodityType = (row) => {
  const id = Number(row.commodityId);
  if (id === 1) return 'electric';
  if (id === 2) return 'gas';

  const commodity = String(row.commodity || '').trim().toLowerCase();
  if (commodity === 'electric' || commodity === 'electricity') return 'electric';
  if (commodity === 'gas' || commodity === 'natural gas') return 'gas';

  return null;
};

export const createAssociationColumns = ({ nameHeader, aliasHeader = 'Rate Class', masterHeader = 'Master Rate Class', supplierHeader = 'Supplier', showAliasColumn = true, showMasterColumn = false, showSupplierColumn = false, onDelete }) => [
  ...showAliasColumn ? [{
    id: 'rateClassName',
    header: () => (
      <span className="d-inline-flex align-items-center">
        <span style={{ width: 18, display: 'inline-flex' }} />
        <span className="ms-1">{aliasHeader}</span>
      </span>
    ),
    accessorKey: 'rateClassName',
    cell: ({ row }) => {
      const type = getCommodityType(row.original);

      return (
        <span className="d-inline-flex align-items-center">
          <span style={{ width: 18, display: 'inline-flex', justifyContent: 'center' }}>
            {type ? <CommodityIcon type={type} /> : null}
          </span>
          <span className="ms-1">{row.original.rateClassName}</span>
        </span>
      );
    },
  }] : [],
  ...showMasterColumn ? [{
    id: 'masterRateClassName',
    header: masterHeader,
    accessorKey: 'masterRateClassName',
    cell: ({ getValue }) => getValue() || '-',
  }] : [],
  {
    id: 'companyName',
    header: showAliasColumn ? nameHeader : () => (
      <span className="d-inline-flex align-items-center">
        <span style={{ width: 18, display: 'inline-flex' }} />
        <span className="ms-1">{nameHeader}</span>
      </span>
    ),
    accessorFn: (row) => showSupplierColumn ? row.utilityName || '' : row.utilityName || row.supplierName || '',
    cell: ({ row }) => {
      const name = showSupplierColumn ? row.original.utilityName || '' : row.original.utilityName || row.original.supplierName || '';
      const type = getCommodityType(row.original);

      if (showAliasColumn) return name;

      return (
        <span className="d-inline-flex align-items-center">
          <span style={{ width: 18, display: 'inline-flex', justifyContent: 'center' }}>
            {type ? <CommodityIcon type={type} /> : null}
          </span>
          <span className="ms-1">{name}</span>
        </span>
      );
    },
  },
  ...showSupplierColumn ? [{
    id: 'supplierName',
    header: supplierHeader,
    accessorKey: 'supplierName',
  }] : [],
  {
    id: 'actions',
    header: 'Action',
    accessorFn: (row) => row.utilityRateClassId || row.supplierRateClassId,
    enableSorting: false,
    cell: ({ row }) => (
      <LoadingButton variant="link" size="sm" className="text-danger p-0" onClick={() => onDelete(row.original)} aria-label="Delete">
        <i className="uil uil-trash" />
      </LoadingButton>
    ),
  },
];
